import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import ReactAudioPlayer from 'react-audio-player';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import SubmissionDetailContent from "../../views/retriever/SubmissionDetailContent.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Avatar,
  Icon,
} from '@material-ui/core';

class CompareAnswerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  render() {
    let answerData = this.props.parent.state.currentAnswerData;
    if (answerData == null) {
      return (<div/>);
    }
    let icon = "";
    if (answerData.kind == "2") {
      icon = "list"
    } else if (answerData.kind == "4") {
      icon = "mic";
    }
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
          scroll='paper'
        >
          <DialogTitle>
            <Icon style={{fontSize: '36px', verticalAlign:'middle'}}>
              {icon}
            </Icon>
            {answerData['content']}
          </DialogTitle>
          <DialogContent>
            {this.props.parent.state.compareAnswerList.map( (row, i) => {
              let targetAnswerData = null;
              let stage_list = row['stage_list'];
              for (let i = 0; i < stage_list.length; i++) {
                let stage = stage_list[i];
                let answer_list = stage['answer_list'];
                for (let j = 0; j < answer_list.length; j++) {
                  let answer = answer_list[j];
                  if (answer['playback_id'] == answerData['playback_id']) {
                    targetAnswerData = answer;
                  }
                }
              }
              return (
                <div>
                  <List>
                    <If condition={targetAnswerData != null}>
                      <Then>
                        <ListItem>
                          <ListItemIcon>
                            <Icon style={{fontSize:'36px'}}>face</Icon>
                          </ListItemIcon>
                          <ListItemText
                            primary={row['submission_data']['user_name']}
                            secondary={Localization.strings.SUBMITTED + " " + (targetAnswerData? targetAnswerData.update_time : "")}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon><Icon></Icon></ListItemIcon>
                          <SubmissionDetailContent root={this.props.root} parent={this} answerData={targetAnswerData} />
                        </ListItem>
                      </Then>
                      <Else>
                        <ListItem>
                          <ListItemIcon>
                            <Icon style={{fontSize:'36px'}}>face</Icon>
                          </ListItemIcon>
                          <ListItemText
                            primary={row['submission_data']['user_name']}
                            secondary="has not answered"
                          />
                        </ListItem>
                      </Else>
                    </If>
                  </List>
                  <Divider/>
                </div>
              );
            })}
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CLOSE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default CompareAnswerDialog;
